<template>
  <symbol
    id="pin-spot-restroom-male"
    viewBox="0 0 60 67.904"
  >
    <g transform="translate(-430.727 -51.299)">
      <path
        d="M490.727,81.3a30,30,0,0,0-29.7-30,30.325,30.325,0,0,0-30.3,29.783,30.01,30.01,0,0,0,19.4,28.285,15.231,15.231,0,0,1,5.766,3.933,62.259,62.259,0,0,1,4.32,5.618.689.689,0,0,0,1.087.036c1.683-2.007,3.411-4.3,5.176-6.133a15.38,15.38,0,0,1,5.357-3.646,30.01,30.01,0,0,0,18.9-27.877"
        transform="translate(0 0)"
      />
      <path
        d="M462.359,65.059a4.425,4.425,0,1,1-4.424-4.425,4.424,4.424,0,0,1,4.424,4.425"
        transform="translate(2.793 1.145)"
        fill="#fff"
      />
      <path
        d="M458.032,87.462h0a5.321,5.321,0,0,1-5.322-5.321V73.559a5.322,5.322,0,0,1,10.644,0V82.14a5.321,5.321,0,0,1-5.321,5.321"
        transform="translate(2.695 2.077)"
        fill="#fff"
      />
      <path
        d="M455.84,97.216h0a1.511,1.511,0,0,1-1.511-1.51V82.439h3.021V95.706a1.511,1.511,0,0,1-1.51,1.51"
        transform="translate(2.894 3.818)"
        fill="#fff"
      />
      <path
        d="M459.391,97.216h0a1.511,1.511,0,0,1-1.51-1.51V82.439H460.9V95.706a1.511,1.511,0,0,1-1.511,1.51"
        transform="translate(3.329 3.818)"
        fill="#fff"
      />
    </g>
  </symbol>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// restroom_male.vue?15a7a344